// Social
import React from 'react';
import PropTypes from 'prop-types';

const Social = ({ className = "", ...props }) => {
  const classNames = [ "common-social uk-icon-button", className ].join(" ");

  return (
    <a
      href={ props.url }
      className={ classNames }
      data-uk-icon={ props.icon }
      aria-label={ props.aria }>
    </a>
  );
};

Social.propTypes = {
  url: PropTypes.string,
  icon: PropTypes.string,
  aria: PropTypes.string,
  className: PropTypes.PropTypes.any
};

export default Social;



// WEBPACK FOOTER //
// ./src/features/common/Social.js